module.exports = __webpack_public_path__ + "frame-59ed99bf/favicon-16613757887737882b31a560f5512224.ico";